import AdList from '../views/advertisingManagement/adList'
import ClickLog from '../views/advertisingManagement/clickLog'
import AnnouncementManagement from '../views/advertisingManagement/announcementManagement'

import Main from '../views/main'
const AdvertisingRouter = {
  path: '/ad-List',
  component: Main,
  title: '广告管理',
  icon: 'el-icon-s-fold',
  meta: { keepAlive: true },
  children: [
    {
      path: '/ad-List',
      component: AdList,
      name: 'adList',
      title: '广告列表',
      meta: { title: '广告列表' ,keepAlive: true }
    },
    {
      path: '/click-Log',
      component: ClickLog,
      name: 'clickLog',
      title: '点击日志',
      meta: { title: '点击日志' ,keepAlive: true }
    },
    {
      path: '/announcement-Management',
      component: AnnouncementManagement,
      name: 'announcementManagement',
      title: '公告管理',
      meta: { title: '公告管理' ,keepAlive: true }
    }
  ]
}
export default AdvertisingRouter
